import React, { useState } from 'react';

function VerifyCard({ verifierCarte }) {

  const [numeroCarte, setNumeroCarte] = useState('');
  const [erreur, setErreur] = useState(null);

  const verifyCard = (e) => {
    e.preventDefault();
    // Vérifiez la validité de la carte
    if (numeroCarte === '') {
      setErreur('Veuillez entrer le numéro de la carte');
    } else {
      // Simuler la vérification de la carte
      const carteValide = true;
      if (carteValide) {
        setErreur(null);
        verifierCarte(true);
      } else {
        setErreur('La carte est invalide');
      }
    }
  };
  return (
    <div className="verifier-carte">
      <h2>Vérifier la validité de la carte</h2>
      <form onSubmit={verifyCard}>
        <label>
          Numéro de la carte :
          <input
            type="text"
            value={numeroCarte}
            onChange={(e) => setNumeroCarte(e.target.value)}
          />
        </label>
        {erreur && <p style={{ color: 'red' }}>{erreur}</p>}
        <button type="submit">Vérifier</button>
      </form>
    </div>
  )
}

export default VerifyCard